import { memo, useCallback, useEffect, useState } from 'react';

import { Button } from 'antd';
import cn from 'classnames';

import ChatBotIcon from '@/shared/assets/icons/chat-bot.svg';

import cls from './chat-bot-placeholder-button.module.css';

const CHATBOT_TOGGLE_EVENT = 'chatbot:toggle';
const CHATBOT_STATE_EVENT = 'chatbot:state';

export const ChatBotPlaceholderButton = memo(() => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleStateChange = (event: CustomEvent<{ isOpen: boolean }>) => {
            setIsOpen(event.detail.isOpen);
        };

        window.addEventListener(
            CHATBOT_STATE_EVENT,
            handleStateChange as EventListener,
        );

        return () => {
            window.removeEventListener(
                CHATBOT_STATE_EVENT,
                handleStateChange as EventListener,
            );
        };
    }, []);

    const handleClick = useCallback(() => {
        window.dispatchEvent(new CustomEvent(CHATBOT_TOGGLE_EVENT));
    }, []);

    return (
        <Button
            className={cn(cls.root, { [cls.active]: isOpen })}
            data-tour="dashboard-chatbot"
            icon={<ChatBotIcon className={cls.icon} />}
            onClick={handleClick}
            shape="circle"
            size="small"
        />
    );
});

ChatBotPlaceholderButton.displayName = 'ChatBotPlaceholderButton';
